import { makeObservable, observable, action } from 'mobx';
import { getStoredCountry, getStoredCurrency } from '../utils/cookieUtils';

export default class LocaleStore {
  @observable refreshTrigger = 0;

  constructor() {
    makeObservable(this);
  }

  @action
  triggerRefresh() {
    this.refreshTrigger += 1;
  }

  getCurrentCountry() {
    return getStoredCountry();
  }

  getCurrentCurrency() {
    return getStoredCurrency();
  }
}

export const localeStore = new LocaleStore(); 